import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, Users, ArrowLeft } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const OrgSwitch: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-[var(--bg-primary)] flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-heading-2 text-[var(--text-primary)] mb-2">
            Select Organization
          </h1>
          <p className="text-body text-[var(--text-secondary)]">
            Choose your organization to continue
          </p>
        </div>

        {/* Organization Cards */}
        <div className="space-y-4 mb-6">
          <div className="card hover:shadow-lg cursor-pointer border-2 border-transparent hover:border-[var(--color-primary-300)]">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-gradient-primary rounded-lg flex items-center justify-center">
                <Building2 className="w-6 h-6 text-white" />
              </div>
              <div className="flex-1">
                <h3 className="text-heading-4 text-[var(--text-primary)]">
                  Occitanie Cooperative
                </h3>
                <p className="text-body-sm text-[var(--text-secondary)]">
                  Regional agricultural cooperative
                </p>
                <div className="flex items-center mt-1 space-x-4">
                  <span className="text-caption text-[var(--color-primary-600)]">COOP</span>
                  <span className="text-xs text-[var(--text-tertiary)]">
                    <Users className="w-3 h-3 inline mr-1" />
                    24 members
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="card hover:shadow-lg cursor-pointer border-2 border-transparent hover:border-[var(--color-primary-300)]">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-gradient-secondary rounded-lg flex items-center justify-center">
                <Building2 className="w-6 h-6 text-white" />
              </div>
              <div className="flex-1">
                <h3 className="text-heading-4 text-[var(--text-primary)]">
                  Domaine Les Vignes
                </h3>
                <p className="text-body-sm text-[var(--text-secondary)]">
                  Private vineyard estate
                </p>
                <div className="flex items-center mt-1 space-x-4">
                  <span className="text-caption text-[var(--color-secondary-600)]">FARM</span>
                  <span className="text-xs text-[var(--text-tertiary)]">
                    <Users className="w-3 h-3 inline mr-1" />
                    8 members
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Current User Info */}
        {user && (
          <div className="bg-[var(--surface)] border border-[var(--border-light)] rounded-lg p-4 mb-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-[var(--text-primary)]">{user.name}</p>
                <p className="text-xs text-[var(--text-secondary)] capitalize">{user.role}</p>
              </div>
              <span className="text-xs px-2 py-1 bg-[var(--color-success)] text-white rounded-full">
                Active
              </span>
            </div>
          </div>
        )}

        {/* Back Link */}
        <Link
          to="/dashboard"
          className="flex items-center justify-center space-x-2 text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          <span className="text-sm">Back to Dashboard</span>
        </Link>
      </div>
    </div>
  );
};

export default OrgSwitch;